<div>
	Anyone at EforAll can create a dashboard, and is encouraged to do so.
	Simply select a dataset, a display type, and an initial set of filters.
	The dashboards you create are your own and remain private, unless you decide to share them.
</div>
<div>
	<ul>
		<li>
			<b>Dataset:</b>
			Think of a dataset as a single sheet within a spreadsheet.
			It has columns (also known as fields) and rows. Datasets
			read live data, so each time you open your dashboard, you may see updated information.
		</li>
		<li>
			<b>Display type:</b>
			Select the type of visualization you would like this dataset represented as.
			We will add new display types over time.
		</li>
		<li>
			<b>Filters:</b>
			Some of the datasets have a lot of rows.
			Use filters to create dashboards that focus on a specific subset.
			For instance, you can build a dashboard that is tied to a year, trimester, accelerator, and/or demographic.
			Don't worry, these filters can be changed later.
		</li>
	</ul>
</div>

<div class="droplist-row">
	<label>Dataset:</label>
	<droplist [items]='datasetItems()' [selectedItem]='selectedDatasetItem()'
		(selectionChange)='onDatasetChange($event)' [filterable]='false' [navigation]='true' sortBy='customSort'
		style='display:inline-block'>
	</droplist>
	<button class="btn" [disabled]="selectedDatasetItem() === undefined" (click)="selectDataset()">Select</button>

</div>